import { vRdxUserInfo } from "../../Redux/roStore";
import {
  PutAway_DOCUMENTNO_GETROW,
  PutAway_Generation_Attributes,
  PutAway_GetStatusDetails,
} from "../../Server/ApiV2";

export const GetAttributes = async (setVocherType, setUserList) => {
  const vRdxUserInfoObj = vRdxUserInfo();
  var vObj = {
    UserCd: vRdxUserInfoObj.UserID,
    UserGrp: vRdxUserInfoObj.UserGroupCode,
  };
  const iAttributes = await PutAway_Generation_Attributes(vObj);
  if (iAttributes?.status === 200) {
    setVocherType(iAttributes?.data?.ResultSet?.VoucherTypes);
    setUserList(iAttributes?.data?.ResultSet?.Users);

    return iAttributes?.data?.ResultSet;
  } else {
    return [];
  }
};

export const Get_PutAway_DOCUMENTNO_GETROW = async (
  VocTyp = "",
  VocNo = "",
  exact = "N",
  AnyData = "",
  Cd = "",
  Name = "",
) => {
  var vObj = {
    VocTyp: VocTyp,
    VocNo: VocNo,
    AnyData: AnyData,
    Cd: Cd,
    Name: Name,
    exact: exact,
  };
  const iresp = await PutAway_DOCUMENTNO_GETROW(vObj);
  if (iresp?.status === 200) {
    return iresp?.data?.ResultSet.data;
  } else {
    return [];
  }
};
export const Get_PutAway_GetStatusDetails = async (
  VocTyp = "",
  VocNo = 0,
  setFormState = () => {},
  userList=[]
) => {
  var vObj = {
    VocTyp: VocTyp,
    VocNo: VocNo,
  }; 
  const iresp = await PutAway_GetStatusDetails(vObj);
  if (iresp?.status === 200) {
 
    setFormState((pre) => ({ 
        ...pre,
      grnStatus: iresp?.data?.ResultSet.GRNStatus||'',
      putAwayStatus: iresp?.data?.ResultSet.PutAwayStatus||'',
      status: iresp?.data?.ResultSet.Status||'',
      mode:iresp?.data?.ResultSet.Type ||"M",
      selectedUsers: iresp?.data?.ResultSet.UserDetails||[],
      selectAll: iresp?.data?.ResultSet.UserDetails.length === userList.length,
    }));
    console.log(iresp?.data?.ResultSet);

    return iresp?.data?.ResultSet;
  } else {
    return [];
  }
};
